module.exports = __webpack_public_path__ + "static/img/46.ba0b863.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/publicService/enterpriseDia/46.png
// module id = itiQ
// module chunks = 2